import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Divider,
  Table,
  Drawer,
} from 'antd';
import dayjs from 'dayjs';
import { toISTDate } from '@Apis/constants';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import UserActions from '@Actions/userActions';
import H3Modal from '@Uilib/H3Modal';
import ViewPurchaseRequest from '@Components/Purchase/PurchaseRequests/ViewPurchaseRequest';
import PRZText from '../../../../Common/UI/PRZText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import MoreInfoMobileView from '../../../../Common/MoreInfoMobileView';
import H3Image from '../../../../../uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
/**
 * @param status
 */
class PurchaseRequestsList extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      limit: 10,
      startDate: dayjs().valueOf(),
      openSelectedDuration: dayjs().subtract(300, 'd').valueOf(),
      closedSelectedDuration: 'LAST 60 DAYS',
      openPurchaseOrderModal: false,
      openGRNModal: false,
      openGRNModalView: false,
      openUpdatePurchaseOrderModal: false,
      expandedRowKeys: [],
      purchaseRequestColumns: [
        {
          title: '',
          render: (record) => (
              <div className="mobile-list__card">
                <div className="mobile-list__card_header">
                  <div className="mobile-list__card_header-left">
                    <PRZText text={`${record?.pr_number}`} className="mobile-list__card_item-number" />
                  </div>
                  <div className="mobile-list__card_header-right" >
                    <PRZText
                      text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                      className="qr__status"
                      style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                    /> 
                  </div>
                </div>
                <div className="mobile-list__card_body">
                  <div className="mobile-list__card_body-left">
                    <div className="mobile-list__card_item-details">
                      {`Business Unit - ${record.tenant_info?.tenant_name}`}
                    </div>
                    <div className="mobile-list__card_item-details">
                      {`Items - ${record.no_of_items}`}
                    </div>
                    <PRZText text={`Delivery Date - ${toISTDate(record?.delivery_date).format('DD/MM/YYYY')}`} className="mobile-list__card_item-details" />  
                    <div className="mobile-list__card_item-details">
                      <PRZText text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} />
                    </div>
                  </div>
                </div>
                <Divider className="mobile-list__card_divider" />
                <div className="mobile-list__card_footer">
                  <div className="mobile-list__card_footer-right">
                    <PRZText
                      className="mobile-list__card__view-more_wrapper"
                      onClick={() => {
                        this.setState({ selectedPRForMobile: record, moreDetailsDrawer: true });
                      }}
                      text={(
                        <span className="mobile-list__card__view-more-text_wrapper">
                          <span className="mobile-list__card__view-more-text">More Info</span>
                          <FontAwesomeIcon
                            className="mobile-list__card__view-more-icon"
                            icon={faAnglesRight}
                          />
                        </span>
                      )}
                    />
                  </div>
                </div>
                <Drawer
                  open={this.state?.moreDetailsDrawer}
                  width="420px"
                  mask
                  onClose={() => this.setState({ moreDetailsDrawer: false })}
                  destroyOnClose
                >
                  <div className="custom-drawer__header-wrapper">
                    <div
                      className="custom-drawer__header"
                      style={{ width: '370px' }}
                    >
                      <H3Text
                        text={`${this.state?.selectedPRForMobile?.pr_number}`}
                        className="custom-drawer__title"
                      />
                      <H3Image
                        src={closeIcon}
                        className="custom-drawer__close-icon"
                        onClick={() => this.setState({ moreDetailsDrawer: false })}
                      />
                    </div>
                  </div>
                  <MoreInfoMobileView
                    description={this.state?.selectedPRForMobile?.description}
                    customFields={this.state?.selectedPRForMobile?.custom_fields}
                    fields={this.ListScreenKeys({ documentData: this.state?.selectedPRForMobile, })}
                  />
                </Drawer>
              </div>
          ),
          responsive: ['xs'],
        },
        {
          title: '#',
          render: (record) => (
            <div className="column-number__wrapper">
              {record?.purchase_requisition_id}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'BUSINESS UNIT',
          render: (text, record) => (
            <div className="associated-entity">
              {record.tenant_info?.tenant_name}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'ITEM(S)',
          render: (text, record) => (
            <div>
              {record.no_of_items}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'REQUESTOR',
          render: (text, record) => (
            <div>
              <div className="column-date">
                {dayjs(record?.created_at).format('DD/MM/YYYY')}
              </div>
              <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'DELIVERY DATE',
          render: (text, record) => (
            <div>
              {dayjs(record?.delivery_date).format('DD/MM/YYYY')}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: 'STATUS',
          render: (item) => (
            <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
              {Helpers.getStatusColor(item.status).text}
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
        },
        {
          title: '',
          key: 'action',
          render: (text, record) => {
            const { history } = this.props;
            return (
              <div className="list__actions">
                <div
                  className="list__actions-button list__actions-button-dark"
                  onClick={() => {
                    this.setState({ selectedPurchaseRequest: record, showPrModal: true });
                  }}
                >
                  View
                </div>
              </div>
            );
          },
          responsive: ['sm', 'md', 'lg', 'xxl'],
          className: 'list__actions-column',
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { getPendingActions } = props;
      getPendingActions('map_pr', 10, state.currentPage, () => {});
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  ListScreenKeys = ({ documentData }) => {
    const record = documentData;
    
    return [
      {
        label: 'Purchase Request #',
        value: `${record?.purchase_requisition_id}`,
      },
      {
        label: 'BUSINESS UNIT',
        value: record?.tenant_info?.tenant_name,
      },
      {
        label: 'ITEM(S)',
        value: record?.no_of_items,
      },
      {
        label: 'REQUESTOR',
        value: `${record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown'} - (${dayjs(record?.created_at).format('DD/MM/YYYY')})`,
      },
      {
        label: 'DELIVERY DATE',
        value: dayjs(record?.delivery_date).format('DD/MM/YYYY') || '-',
      },
      {
        label: 'STATUS',
        value: record?.status?.split('_').join(' ')?.toProperCase(),
      },
    ];
  };
  /**
   *
   * @param {*} status
   * @return
   */
  render() {
    const {
      pendingActions, getPendingActionsLoading, getPendingActions,
    } = this.props;
    const {
      currentPage, purchaseRequestColumns, showPrModal, selectedPurchaseRequest,
    } = this.state;
    return (
      <Fragment>
        <div className="doc-list__wrapper">
          <div className="ant-row">
            <div className="ant-col-md-24 ant-col-xs-24">
              <div className="doc-list__table-wrapper">
                <Table
                  title={() => (
                    <div className="doc-list__table-header">
                      <div className="doc-list__table-header__left">
                        {`${Number(pendingActions?.pr_approval_count)} Material Requests`}
                      </div>
                    </div>
                  )}
                  loading={getPendingActionsLoading}
                  showHeader
                  size="small"
                  scroll="scroll"
                  columns={purchaseRequestColumns}
                  rowKey="po_id"
                  dataSource={pendingActions?.purchase_requests || []}
                  pagination={(Number(pendingActions?.pr_approval_count) > 10) ? {
                    defaultCurrent: 1,
                    current: currentPage,
                    total: Number(pendingActions?.pr_approval_count),
                    pageSize: 10,
                    onChange: (page) => {
                      getPendingActions('map_pr', 10, page, () => {});
                      this.setState({ currentPage: page });
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: false,
                  } : false}
                />
              </div>
            </div>
          </div>
        </div>
        <H3Modal
          onClose={() => {
            getPendingActions('map_pr', 10, currentPage, () => {});
            this.setState({ showPrModal: false });
          }}
          className="pending-po__view-po"
          isOpen={showPrModal}
          title={`Material Request #${selectedPurchaseRequest ? selectedPurchaseRequest?.pr_number : ''} for ${selectedPurchaseRequest?.tenant_info?.tenant_name}`}
          showHeader
        >
          <ViewPurchaseRequest
            isQuickView
            selectedPrId={selectedPurchaseRequest?.purchase_requisition_id}
            selectedTenantId={selectedPurchaseRequest?.tenant_info?.tenant_id}
          />
        </H3Modal>
      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseRequestReducers
 * @return {{purchaseRequests: *, getPurchaseRequestsLoading: *, user}}
 */
const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
});

const mapDispatchToProps = (dispatch) => ({
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
  getPurchaseRequestsSuccess: (purchaseRequests) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests)),
});

PurchaseRequestsList.propTypes = {
  user: PropTypes.any,
  history: PropTypes.func,
  getPurchaseRequestsSuccess: PropTypes.func,
  selectedPurchaseRequest: PropTypes.any,
  getPendingActions: PropTypes.func,
  getPendingActionsLoading: PropTypes.bool,
  pendingActions: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseRequestsList));
